export default {
    namespaced: true,
    state: {
        banner:"",
        name:"",
        desc:"",
        info:""
    },
    getters: {
    },
    mutations: {
        setImg(state, payload) {
            state.banner = payload
        },
        setName(state, payload) {
            state.name = payload
        },
        setDesc(state, payload) {
            state.desc = payload
        },
        setInfo(state, payload) {
            state.info = payload
        },
    },
    actions: {
    },

}